import {makeObservable, observable} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";
import {WIZARD_WIDGET} from "../../../widgets/wizard-widget/wizard-widget-consts";

export class AppWizardDisplayModel extends BaseWidgetDisplayModel {
  @observable isVisible: Boolean;
  @observable page: Number;
  @observable deviceId: Number;
  @observable deviceType: Number;
  @observable source: String;
  blockDisplay: Boolean;

  constructor() {
    super();

    this.isVisible = false;
    this.blockDisplay = false;
    this.page = WIZARD_WIDGET.DEFAULT_PAGE;
    this.deviceId = null;
    this.deviceType = null;

    makeObservable(this);
  }
}
